export const AdGroupNegativeKeyword = {
  parent: 'AdGroup',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Ad Group Negative Keyword',
    },
    Text: {
      'bulk-upload-header': 'Keyword',
    },
    MatchType: {
      'bulk-upload-header': 'Match Type',
    },
  },
};
